// extracted by mini-css-extract-plugin
export default {"reviewPolicyButton":"sJ91U","reviewPolicyButtonContainer":"OuvRr"};